import { BuildingOffice2Icon } from '@heroicons/react/24/solid';
import { FC } from 'react';

interface MultiHotelIndicatorProps {
  hotelCount: number;
}

const MultiHotelIndicator: FC<MultiHotelIndicatorProps> = ({ hotelCount }) => {
  return (
    <div className="inline-flex items-center rounded-full bg-blue-50 px-3 py-1 text-xs font-medium text-blue-700 ring-1 ring-blue-700/10 sm:text-sm">
      <BuildingOffice2Icon className="mr-1.5 size-3 sm:size-4" />
      <span className="hidden sm:inline">
        This option includes {hotelCount} hotels
      </span>
      <span className="sm:hidden">{hotelCount} hotels</span>
    </div>
  );
};

export default MultiHotelIndicator;
